import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            'AIzaSyB4Xnt9iHSk0sJodKdK1L08LyLhC1AyL_E',
  authDomain:        'proparv-5ab15.firebaseapp.com',
  projectId:         'proparv-5ab15',
  storageBucket:     'proparv-5ab15.firebasestorage.app',
  messagingSenderId: '382127964801',
  appId:             '1:382127964801:web:f17977469681e55f5fc380',
  measurementId:     'G-NG5ZYQ829Z',
};

const app      = initializeApp(firebaseConfig);
export const auth           = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

/**
 * Open Google sign-in popup and return { idToken, firebaseUser }.
 * Call this from any page — after success send idToken to /api/auth/google.
 */
export async function signInWithGoogle() {
  const result  = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();
  return { idToken, firebaseUser: result.user };
}

export async function signOutFirebase() {
  await signOut(auth);
}
